import addImageAnimations from "./imageAnimations"
import addLogoAnimation from "./logoAnimation"
import hydrateForm from "./hydrateForm"

document.documentElement.classList.remove("no-js")
addLogoAnimation()
addImageAnimations()
hydrateForm()
